import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-up-left', 'ChevronUpLeft', [["path",{"d":"M7.879 16.364V7.879h8.485","key":"svg-0"}]]);